import { createSlice } from "@reduxjs/toolkit";
import API from "../../services/api";
import { USERS_API_URL } from "../../config/service";
import { showError } from "../messages/messagesSlice";

export const adminListDataSlice = createSlice({
  name: "adminlistdata",
  initialState: {
    adminlistdata: [],
  },
  reducers: {
    setAdminListData: (state, action) => {
      if (action.payload) {
        state.adminlistdata = action.payload;
      }
    },
  },
});

export const { setAdminListData } = adminListDataSlice.actions;


export const listAdminUserData = (cso_identifier) => async( dispatch )=>{
  try{
      API.get(`${USERS_API_URL}/v1/users/adminlist/${cso_identifier}`).then((response)=> {
      dispatch(setAdminListData(response.data))});
  } catch (error) {
    dispatch(
      showError({ message: `Admin List data retrieval failed. ${error.message}` })
    );
  }
};


export const selectAdminListData = (state) => state.adminlistdata.adminlistdata;

export default adminListDataSlice.reducer;